import React from 'react';
import { Button } from 'semantic-ui-react';
import * as Yup from 'yup';

import Form from 'src/components/form';
import { Typography } from 'src/components/coreUI';
import {
  updateUserAssignmentFile,
  UserAssignmentFilePayload,
} from 'src/thunks/user_assignment';
import { useForm } from 'src/hooks';
import { useAppDispatch } from 'src/store';
import { CONTENT_TYPE, UPLOAD_MODULE } from 'src/constants/app';

type Props = {
  initialValues?: UserAssignmentFilePayload;
  onClose?: Function;
};

const getFileEtx = (fileUrl?: string): CONTENT_TYPE | '' => {
  if (!fileUrl) return '';

  if (fileUrl.includes('pdf')) return CONTENT_TYPE.PDF;
  if (
    fileUrl.includes('png') ||
    fileUrl.includes('jpeg') ||
    fileUrl.includes('jpg')
  )
    return CONTENT_TYPE.IMAGE;
  if (fileUrl.includes('docx') || fileUrl.includes('doc')) return '';

  return '';
};

const UpdateFileForm: React.FC<Props> = ({ initialValues, onClose }) => {
  const dispatch = useAppDispatch();

  const { submitForm, isSubmitting, getFieldInfo, values, setFieldValue } =
    useForm<UserAssignmentFilePayload>({
      initialValues: { ...initialValues },
      validationSchema: Yup.object().shape({
        name: Yup.string().required().label('File name'),
        url: Yup.string().required().label('File'),
      }),
      async onSubmit(value) {
        await dispatch(updateUserAssignmentFile(value));
        onClose?.();
      },
      enableReinitialize: true,
    });

  return (
    <Form>
      <Typography.Title>UPDATE SUBMISSION FILE</Typography.Title>
      <Form.Input
        label="FILE NAME"
        placeholder="File name"
        {...getFieldInfo('name')}
      />
      <Form.Dropzone
        module={UPLOAD_MODULE.OTHERS}
        label="FILE URL"
        placeholder="Update your submission file"
        value={{
          url: values.url,
          origin: { name: values.name, type: getFileEtx(values.url) },
        }}
        onChange={(file) => {
          setFieldValue('url', file[0].url);
          setFieldValue('name', file[0].origin.name);
        }}
      />

      <Button
        primary
        onClick={submitForm}
        loading={isSubmitting}
        className="d-block margin-left-auto"
      >
        Update
      </Button>
    </Form>
  );
};

export default UpdateFileForm;
